import { faEllipsisVertical } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@shared/components/ui/dropdown-menu';
import type { CRMModel } from '../../models/CRM';

interface ActionItem {
  id: string;
  label: string;
  enabled: boolean;
  icon: any;
  onClick: () => void;
}

interface DropdownActionsProps {
  order: CRMModel;
  actions?: ActionItem[];
}

export const DropdownActions = ({ order, actions }: DropdownActionsProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-hover-press transition-colors"
          data-testid={`crm-actions-dropdown-${order.id}`}
        >
          <FontAwesomeIcon icon={faEllipsisVertical} className="w-4 h-4 text-icons" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {actions?.map((action) => (
          <DropdownMenuItem
            key={action.id}
            onClick={() => action.onClick()}
            disabled={!action.enabled}
            data-testid={`${action.id}-order-${order.id}`}
          >
            <FontAwesomeIcon
              icon={action.icon}
              className={`mr-2 w-3.5 h-3.5 ${action.id === 'confirm' ? 'text-success' : action.id === 'cancel' ? 'text-error' : ''}`}
            />
            {action.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
